<section class="locked-feature" aria-label="Intelligence report preview">
  <div class="preview-grid" aria-hidden="true">
    @for (card of content.cards; track card; let index = $index) {
      <div class="preview-card">
        <span class="preview-label">{{ card }}</span>
        <div class="skeleton skeleton-value"></div>
        <div class="skeleton skeleton-caption"></div>
        @if (index % 2 === 1) {
          <div class="chart-silhouette">
            @for (height of [30, 55, 42, 72, 63, 88, 78]; track $index) {
              <span [style.height.%]="height"></span>
            }
          </div>
        } @else {
          <div class="skeleton skeleton-track"></div>
        }
      </div>
    }
  </div>
  <div class="upgrade-card">
    <span class="lock-symbol" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7">
        <rect x="5" y="10" width="14" height="11" rx="3"/>
        <path d="M8 10V7a4 4 0 0 1 8 0v3M12 14v3" stroke-linecap="round"/>
      </svg>
    </span>
    <p class="premium-label">Circled Intelligence (CI)</p>
    <h2>{{ headline || content.headline }}</h2>
    <p class="description">{{ description || content.description }}</p>
    <a [routerLink]="upgradeDestination" class="upgrade-button">
      {{ ctaLabel || content.ctaLabel }} <span aria-hidden="true">↗</span>
    </a>
    <p class="secondary">Full insights with Intelligence and Advisory plans.</p>
  </div>
</section>
